module.exports = __webpack_public_path__ + "static/media/pesacode.1cf62eab.png";